import http from '@/http'
export const state = {
    forms_list: [],
    questions: [],
    questions_deleted: [],
    alternatives_deleted: [],
}

export const mutations = {
    setQuestions(state, payload) {
        state.questions = payload;
    },

    resetQuestions(state) {
        state.questions = [];
        state.questions_deleted = [];
        state.alternatives_deleted = [];
    },

    addQuestion(state, question) {
        state.questions.push(question);
    },

    editQuestion(state, payload) {
        state.questions[payload.index] = payload.question;
    },

    removeQuestion(state, index) {
        if (typeof  state.questions[index].id === 'number') {
            state.questions_deleted.push(state.questions[index].id);
        }
        state.questions.splice(index, 1);
    },

    removeAlternative(state, id) {
        state.alternatives_deleted.push(id);
    },

    setForms(state, payload) {
        state.forms_list = payload;
    }
}
export const actions = {
    getForms({commit}) {
        http.get('formularios/listar')
            .then(response => {
                commit('setForms', response.data.message)
            })
    }
}

